import Swiper from 'swiper';

// Carousels
class Carousel {
  constructor() {
    const galleries = [].slice.call(
      document.querySelectorAll('.product__carousel__items')
    );

    if (galleries.length > 0) {
      galleries.forEach(gallery => {
        this.productCarousel(gallery);
      });
    }
  }

  productCarousel(item) {
    this.swiper = new Swiper(item, {
      centeredSlides: true,
      effect: 'slide',
      loop: false,
      slidesPerView: 1,
      navigation: {
        prevEl: '.product__carousel__arrow--previous',
        nextEl: '.product__carousel__arrow--next',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets'
      }
    });
  }
}

const carouselInit = {
  init() {
    // if element exists init this class
    const carouselElem = [].slice.call(document.querySelectorAll('.carousel'));
    if (carouselElem.length > 0) {
      carouselElem.forEach(el => {
        // eslint-disable-next-line no-unused-vars
        const carouselWrap = new Carousel(el);
      });
    }
  },
};

export default carouselInit;
